// extracted by mini-css-extract-plugin
export var titlteContainer = "JoinUs-module--titlteContainer--N3gqt";
export var title = "JoinUs-module--title--SXusE";
export var titleIllustration = "JoinUs-module--titleIllustration--S-QAi";
export var intro = "JoinUs-module--intro--JSuDU";
export var contentContainer = "JoinUs-module--contentContainer--7jsCM";
export var background = "JoinUs-module--background--kWUwo";
export var singleContentBlock = "JoinUs-module--singleContentBlock--rgwt6";
export var singleContentBlockTitle = "JoinUs-module--singleContentBlockTitle--3yFN4";
export var singleContentText = "JoinUs-module--singleContentText--5ol7F";